import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import gsap from 'gsap'
import { useRetroMode } from '../../context/RetroModeContext'

// Crossfades through a list of phrases. Replaces the old Typewriter-effect
// usages (a very common "template portfolio" tell) with a GSAP-driven fade.
const CyclingText = forwardRef(
  ({ phrases, interval = 2800, as: Tag = 'span', ...rest }, forwardedRef) => {
    const innerRef = useRef(null)
    const index = useRef(0)
    const [text, setText] = useState(phrases[0])
    const { retroMode } = useRetroMode()

    useImperativeHandle(forwardedRef, () => innerRef.current)

    useEffect(() => {
      if (retroMode || phrases.length < 2) return undefined
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches
      if (reduceMotion) return undefined

      const id = setInterval(() => {
        const el = innerRef.current
        if (!el) return
        gsap.to(el, {
          opacity: 0,
          y: -10,
          duration: 0.35,
          onComplete: () => {
            index.current = (index.current + 1) % phrases.length
            setText(phrases[index.current])
            gsap.fromTo(
              el,
              { opacity: 0, y: 10 },
              { opacity: 1, y: 0, duration: 0.35 },
            )
          },
        })
      }, interval)

      return () => clearInterval(id)
    }, [retroMode, phrases, interval])

    return (
      <Tag ref={innerRef} {...rest}>
        {text}
      </Tag>
    )
  },
)

export default CyclingText
